import { render, staticRenderFns } from "./ContactMultiSelect.vue?vue&type=template&id=53b32096&"
import script from "./ContactMultiSelect.vue?vue&type=script&lang=js&"
export * from "./ContactMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports